/**
 * Wire the bundled, DTA-clean assets into a ready-to-use engine context.
 *
 * Assets are produced by `modn/scripts/export_structural_app_assets.py`:
 *   - `Models/gates/tree_*.json` — skip-logic gate graph (derived structure),
 *   - `Models/feature_position.json` — questionnaire order for tie-breaks,
 *   - (`Models/questions.json` + `Models/questions.i18n.json` drive the UI).
 *
 * No patient data is bundled — the structural picker + DISC-5 criteria need none.
 */
import treeGAD from '../Models/gates/tree_GAD.json';
import treeMDD from '../Models/gates/tree_MDD.json';
import treePTSD from '../Models/gates/tree_PTSD.json';
import treeSoPh from '../Models/gates/tree_SoPh.json';
import featurePositionJson from '../Models/feature_position.json';
import {GateGraph, loadGateGraph, TreeDoc} from './gates';
import {AppContext, buildAppContext} from './session';

let cached: AppContext | null = null;

export const buildBundledGateGraph = (): GateGraph =>
  loadGateGraph([treeSoPh, treeGAD, treeMDD, treePTSD] as unknown as TreeDoc[]);

export const bundledFeaturePosition = (): Map<string, number> =>
  new Map<string, number>(
    Object.entries(featurePositionJson as Record<string, number>),
  );

/** Build (and memoise) the shared consultation context from bundled assets. */
export const getAppContext = (): AppContext => {
  if (cached === null) {
    cached = buildAppContext(buildBundledGateGraph(), bundledFeaturePosition());
  }
  return cached;
};
